import { Platform } from "../types/Platforms";

export const VIDEO_PLATFORMS: Platform[] = [
  Platform.YOUTUBE_SHORTS,
  Platform.INSTAGRAM_REELS,
  Platform.TIKTOK_REELS,
  Platform.FACEBOOK_REELS,
  Platform.LINKEDIN_REELS,
];

/**
 * Check if a platform supports video content
 * @param platform The platform to check
 * @returns true if the platform supports video content
 */
export const isVideoPlatform = (platform: Platform): boolean => {
  return VIDEO_PLATFORMS.includes(platform);
};
